import Action from 'components/Content/Action/Action';

export default Action;
